module.exports = __webpack_public_path__ + "files/9d4996e2c0e406081f2f5021d05e3288.png";